import { render, staticRenderFns } from "./SkeletonQuoteInsurance.vue?vue&type=template&id=2774dc62&scoped=true"
import script from "./SkeletonQuoteInsurance.vue?vue&type=script&lang=js"
export * from "./SkeletonQuoteInsurance.vue?vue&type=script&lang=js"
import style0 from "./SkeletonQuoteInsurance.vue?vue&type=style&index=0&id=2774dc62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2774dc62",
  null
  
)

export default component.exports